'use client'

import { ReactNode } from 'react'
import { ConsentGate } from '@/features/gdpr/consent-gate'
import { AddressSearchPlaceholder } from '@/features/gdpr/placeholders/address-search-placeholder'
import { THIRD_PARTY_PURPOSE } from '@/features/gdpr/use-purpose-consent'
import { PlacesApiProvider } from '@/features/google-places/google-places-api-provider'

const ADDRESS_SEARCH_INTEGRATION_ID = 'address-search'

interface IAddressSearchConsentGateProps {
    placeholder: (onOpen: () => void) => ReactNode
    children: ReactNode
}

export const AddressSearchConsentGate = ({
    placeholder,
    children,
}: IAddressSearchConsentGateProps) => (
    <ConsentGate
        integrationId={ADDRESS_SEARCH_INTEGRATION_ID}
        purposeId={THIRD_PARTY_PURPOSE}
        placeholder={(activate) => (
            <AddressSearchPlaceholder activate={activate} renderInput={placeholder} />
        )}
    >
        <PlacesApiProvider>{children}</PlacesApiProvider>
    </ConsentGate>
)
